export const getTimezoneOffset = (fallback = 300) => {
  try {
    return new Date().getTimezoneOffset();
  } catch {
    return fallback;
  }
};

export default getTimezoneOffset;